<template>
  <div @click="copyPath()" class="mt-5">

    <m_-button class="btn-warning">
      <b-icon icon="files"></b-icon>
    </m_-button>
    <slot></slot>


  </div>

</template>

<script>
// todo register this button on global section
import m_Button from './Buttons/Button'

export default {
  name: "CopyComponent",
  components: {
    m_Button
  },
  props: {
    path: {
      type: String,
      default: ''
    },
  },
  methods: {
    copyPath() {
      let component_name = this.path.split('/')
      component_name = component_name[component_name.length - 1]
      navigator.clipboard.writeText(`import ${component_name} from @moeinmdn/miw-componnets/plugin/${this.path}`);
    }
  }
}
</script>

<style scoped>

</style>